export enum AppointmentTypes {
  'Surgical Procedure' = 'Surgical Procedure',
  'Dental Procedure' = 'Dental Procedure',
  'Emergency' = 'Emergency',
  'Euthanasia' = 'Euthanasia',
  'Recheck / Follow Up' = 'Recheck / Follow Up',
  'Injury / Illness / Specialty' = 'Injury / Illness / Specialty',
  'Wellness' = 'Wellness',
  'Vaccines + Preventative Services' = 'Vaccines + Preventative Services',
}
